// extracted by mini-css-extract-plugin
export default {"alertBanner":"hfsDHVMcqXLYMLrlxjZW","documentBundle":"z7AQBnuY1FCWC1oeFO1g","completedBanner":"rpSHdE0Y27H4SQ41Wixs","rejectedBanner":"uNhytnJC3FSKxEd7hNw9"};